import store from '../store/store'

export default [

    //////// AUTHENTICATION ROUTES /////////////////////////
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }

            },
        },
    },
    {
        path: '/vendor-manager/login',
        name: 'vendor-login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }

            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }

            },
        },
    },
    {
        path: '/email-verify',
        name: 'auth-email-verify',
        component: () => import('../views/pages/account/email-verify'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }

            },
        },
    },
    {
        name: 'Logout',
        path: '/logout',
        component: () => import('../views/pages/error/logout'),
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }

            },
        },
    },
    {
        path: '/reset-password',
        name: 'Reset-password',
        component: () => import('../views/pages/account/reset-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }

            },
        },
    },
    {
        path: '/admin/login',
        component: () => import('../views/pages/admin/auth/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/branch/login',
        component: () => import('../views/pages/branch/auth/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                // If the user is already logged in
                if (store.getters.GET_USER_INFO) {
                    next({name: 'Home'});
                } else {
                    // Continue to the login page
                    next()
                }

            },
        },
    },
    ///////////////////////// DASHBOARD ROUTES /////////////////////////////////
    {
        path: '/',
        meta: {
            authRequired: true,
            roles: ['customer','vendor_manager']
        },
        component: () => import('../views/pages/vendor'),
        children: [
            {
                path: '/',
                name: 'Home',
                component: () => import('../views/pages/vendor/home/index'),
            },
            {
                path: '/product',
                name: 'Product',
                component: () => import('../views/pages/vendor/product/product'),
            },
            {
                path: '/account',
                name: 'Transactions',
                component: () => import('../views/pages/vendor/transactions/transactions'),
                meta: {
                    authRequired: true,
                    roles: ['customer', 'vendor_manager'],
                    permissions: ['manage_order_transactions']
                }

            },
            {
                path: '/orders',
                'name': 'Orders',
                component: () => import('../views/pages/vendor/orders/index'),
                meta: {authRequired: true, roles: ['customer']}
            },
            {
                path: '/add-orders',
                component: () => import('../views/pages/vendor/orders/add-order'),
                meta: {authRequired: true, roles: ['customer']}
            },
            {
                path: '/upload-orders',
                component: () => import('../views/pages/vendor/orders/upload-orders'),
                meta: {authRequired: true, roles: ['customer']}
            },
            {
                path: '/payment/requests',
                component: () => import('../views/pages/vendor/payments/payment-requests'),
                meta: {
                    authRequired: true, roles: ['customer'],
                    permissions: ['manage_payments']
                }
            },

            {
                path: '/product/:id/stock-history',
                component: () => import('../views/pages/vendor/product/stock-history'),
                meta: {authRequired: true, roles: ['customer']}
            },
            {
                path: '/product/:id/account',
                component: () => import('../views/pages/vendor/product/product-transactions'),
                meta: {authRequired: true, roles: ['customer']}
            },
            {
                path: '/product/:id/orders',
                component: () => import('../views/pages/vendor/product/orders'),
                meta: {authRequired: true, roles: ['customer']}
            },

            {
                path: '/payment/withdrawal',
                component: () => import('../views/pages/vendor/payments/withdrawal'),
                meta: {
                    authRequired: true, roles: ['customer'],
                    permissions: ['manage_payments']
                }
            },
            {
                path: '/manage-users',
                component: () => import('../views/pages/vendor/userManagement/manage-users'),
                meta: {
                    authRequired: true, roles: ['customer'],
                    permissions: ['manage_users']
                }
            },

            // admin links here
            {
                path: '/faq',
                component: () => import('../views/pages/vendor/settings/faqs'),
            },

        ]
    },


    /////////////////////////// ADMIN ROUTES //////////////////////////

    {
        path: '/admin',
        meta: {
            authRequired: true,
            roles: ['admin']
        },
        component: () => import('../views/pages/vendor'),
        children: [
            {
                path: '/admin',
                component: () => import('../views/pages/admin/home/index'),
                meta: {authRequired: true, roles: ['admin']}
            },
            {
                path: '/admin/vendors',
                component: () => import('../views/pages/admin/vendors/index'),
            },
            {
                path: '/admin/vendors/pending',
                component: () => import('../views/pages/admin/vendors/pending'),
            },
            {
                path: '/admin/vendors/rejected',
                component: () => import('../views/pages/admin/vendors/rejected'),
            },
            {
                path: '/admin/orders',
                component: () => import('../views/pages/admin/orders/index'),
            },
            {
                path: '/admin/products',
                component: () => import('../views/pages/admin/products/index'),
            },

            {
                path: '/admin/payment/requests',
                component: () => import('../views/pages/admin/payments/payment-requests'),
                meta: {authRequired: true, roles: ['customer']}
            },
            {
                path: '/admin/product/:id',
                component: () => import('../views/pages/admin/products/product-details'),
            },
            {
                path: '/admin/account',
                component: () => import('../views/pages/admin/account/account'),
            },
            {
                path: '/admin/branches',
                component: () => import('../views/pages/admin/branches/index'),
            },
            {
                path: '/admin/orders/pending-approval',
                component: () => import('../views/pages/admin/orders/pending-approval'),
            },
            {
                path: '/profile',
                component: () => import('../views/pages/vendor/settings/profile'),
            },

            {
                path: '/support/chat',
                component: () => import('../views/pages/vendor/support/chat'),
            },
            {
                path: '/admin/manage/branch/admins',
                component: () => import('../views/pages/admin/userManagement/manage-branch-admins'),
            },
            {
                path: '/admin/account-settings',
                component: () => import('../views/pages/admin/settings/account-settings'),
            }
        ]
    },


    /////////////////////////// BRANCH ROUTES //////////////////////////

    {
        path: '/branch/home',
        component: () => import('../views/pages/branch/account/account'),
        meta: {authRequired: true, roles: ['branch']}
    },
    {
        path: '/branch/orders',
        component: () => import('../views/pages/branch/orders'),
        meta: {authRequired: true, roles: ['branch']}
    },
    {
        path: '/print-preview',
        name: 'PrintPreview',
        component: () => import('../views/pages/branch/orders/print-preview'),
    },

    {
        path: '/branch/products',
        component: () => import('../views/pages/branch/products'),
        meta: {authRequired: true, roles: ['branch']}
    },
    {
        path: '/branch/product/:id',
        component: () => import('../views/pages/branch/products/product-details'),
    },
    {
        path: '/branch/orders/pending-approval',
        component: () => import('../views/pages/branch/orders/pending-approval'),
    },
    {
        path: '/branch/account',
        component: () => import('../views/pages/branch/transactions/transactions'),
    },
    {
        path: '/branch/configurations',
        component: () => import('../views/pages/branch/configuration/index'),
    },
    {
        path: '/branch/account-settings',
        component: () => import('../views/pages/branch/settings/account-settings'),
        meta: {authRequired: true, roles: ['branch']}
    },


    ///////////////////////// CUSTOMER SERVICE ROUTES /////////////////////////////////
    {
        path: '/customer-service',
        component: () => import('../views/pages/customerService/orders/index'),
        meta: {authRequired: true, roles: ['customer_service']}
    },
    {
        path: '/customer-service/orders',
        component: () => import('../views/pages/customerService/orders/index'),
        meta: {authRequired: true, roles: ['customer_service']}
    },
    {
        path: '/customer-service/branches',
        component: () => import('../views/pages/customerService/branches/index'),
        meta: {authRequired: true, roles: ['customer_service']}
    },
    {
        path: '/customer-service/vendors',
        component: () => import('../views/pages/customerService/vendors/index'),
        meta: {authRequired: true, roles: ['customer_service']}
    },
    {
        path: '/customer-service/products',
        component: () => import('../views/pages/customerService/products/index'),
        meta: {authRequired: true, roles: ['customer_service']}
    },
    {
        path: '/customer-service/product/:id',
        component: () => import('../views/pages/customerService/products/product-details'),
    },
    {
        path: '/customer-service/account-settings',
        component: () => import('../views/pages/customerService/settings/account-settings'),
    },


    ///////// EXTRA ROUTES //////////////////////////
    {
        path: '/extras/maintenance',
        name: 'extras-maintenance',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/extras/maintenance')
    },
    {
        path: '/extras/coming-soon',
        name: 'extras-coming-soon',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/extras/coming-soon')
    },
    {
        path: '/error/404',
        name: 'error-404',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/error/404')
    },
    {
        path: '/error/500',
        name: 'error-500',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/error/500')
    },

    {
        path: "*",
        redirect: "/error/404"
    }
]